import Vue from "vue";
import VueRouter from "vue-router";
import LayoutBasic from "@/layouts/LayoutBasic";
import LayoutBasic2 from "@/layouts/LayoutBasic2";
import rolePermissions from "@/router/permissions"; // 导入权限配置
import stu_1LayoutBasic3 from "@/layouts/stu_1LayoutBasic3";
import stu_2LayoutBasic3 from "@/layouts/stu_2LayoutBasic3";
Vue.use(VueRouter);

const routes = [
  // 只要访问根路径就重定向到登录页面
  {
    path: "/",
    redirect: "/loginOLD",
  },
  {
    path: "/login",
    component: () => import("@/components/Login"),
  },
  {
    path: "/loginOLD",
    component: () => import("@/components/loginOLD"),
  },
  {
    path: "/bigScreen",
    component: () => import("@/views/bigScreen"),
  },
  // 上传资源路径
  {
    // 问答资源
    path: "/kgBase/index",
    component: () => import("@/views/kgBase/index.vue"),
    name: 'kgBase'
  },
  {
    // 问答资源
    path: "/kgBase/cardList",
    component: () => import("@/views/kgBase/cardList.vue"),
    name: 'kgBase'
  },

  {
    path: "/home",
    component: LayoutBasic2,
    redirect: "/home",
    children: [
      {
        path: "/home",
        component: () => import("@/views/home"),
      },
      {
        path: "/project",
        component: () => import("@/views/project"),
      },
    ],
  },
  // 学生端课程列表页面
  {
    path: "/home",
    component: stu_1LayoutBasic3,
    redirect: "/home",
    children: [
      {
        path: "/home",
        component: () => import("@/views/home"),
      },
      {
        // 课程
        path: "/stu_project",
        component: () => import("@/views/stu_project"),
        name: 'stu_project'
      },
    ],
  },

  {
    path: "/overview",
    component: LayoutBasic,
    redirect: "/overview",
    //教师端
    children: [
      // {
      //   path: "/capacity/capManage",
      //   component: () => import("@/views/capacity/capManage"),//课程能力管理
      // },
      {
        // 课程知识管理
        path: "/overview",
        component: () => import("@/views/overview"),
        name: '/overview'
      },
      {
        // 课程问题管理
        path: "/problemGraph/probManage",
        component: () => import("@/views/problemGraph/probManage.vue"),
        name: 'probManage'
      },
  
      //能力图谱库
      // {
      //   // 能力本体建模
      //   path: "/capacity/capOntology",
      //   component: () => import("@/views/capacity/capOntology.vue"),
      //   name: 'capOntology'
      // },
      //知识图谱库
      {
        // 知识建模
        path: "/manage/ontology",
        component: () => import("@/views/manage/ontology.vue"),
      },
      {
        // 知识实例管理
        path: "/manage/instance",
        component: () => import("@/views/manage/instance.vue"),
      },
      //问题图谱库
      {
        // 问题本体建模
        path: "/problemGraph/probOntology",
        component: () => import("@/views/problemGraph/probOntology.vue"),
        name: 'probOntology'
      },
      {
        // 问题实例管理
        path: "/problemGraph/probInstance",
        component: () => import("@/views/problemGraph/probInstance.vue"),
        name: 'probInstance'
      },
      //课程知识体系
      // {
      //   // 能力图谱
      //   path: "/capacity/capGraph",
      //   component: () => import("@/views/capacity/capGraph.vue"),
      //   name: 'capGraph'
      // },
      // 知识图谱
      {
        // 知识体系导图
        path: "/relation/conceptmap",
        component: () => import("@/views/relation/conceptmap.vue"),
        name: 'conceptmap'
      },
      //图谱资源
      {
        // 知识点关联展示
        name: 'knowledgedisplay',
        path: "/relation/knowledgedisplay",
        component: () => import("@/views/relation/knowledgedisplay.vue"),
        meta: {
          keepAlive: false
        }
      },
      {
        // 问题知识图谱
        path: "/problemGraph/graph",
        component: () => import("@/views/problemGraph/graph.vue"),
        name: 'problemGraph'
      },
      {
        // 学生管理
        path: "/manage/studentManage",
        component: () => import("@/views/manage/studentManage.vue"),
        name: 'studentManage'
      },
      // {
      //   // 可视化
      //   path: "/manage/depth",
      //   component: () => import("@/views/manage"),
      // },
      // {
      //   // 深度关联展示
      //   path: "/manage/index",
      //   component: () => import("@/views/manage/index.vue"),
      // },
      // {
      //   // 时序关联展示
      //   path: "/manage/timing",
      //   component: () => import("@/views/manage/timing.vue"),
      // },
      // {
      //   // 问题知识库
      //   path: "/relation/questionstore",
      //   component: () => import("@/views/relation/questionstore.vue"),
      //   name:'questionstore'
      // },

      // {

      // 知识更新
      // {
      //   // 知识抽取
      //   path: "/mergeGraph/extract",
      //   component: () => import("@/views/mergeGraph/extract.vue"),
      // },
      // {

      //   path: "/algo/index",
      //   component: () => import("@/views/algo"),
      // },
      // {
      //   //实体标注
      //   path: "/mergeGraph/mark",
      //   component: () => import("@/views/mergeGraph/mark.vue"),
      // },
      // {
      //   path: '/mergeGraph/newExtract',
      //   name: 'mergeGraphNewExtract',
      //   component: () => import('@/views/mergeGraph/newExtract.vue'),
      // },
      // {
      //   path:'/kgBase/index',
      //   name:'kgBase',
      //   component: () => import('@/views/kgBase/index.vue')
      // },
      // {
      //   path:'/kgBase/cardList',
      //   name:'CardList',
      //   component: () => import('@/views/kgBase/cardList.vue')
      // },
      // 知识应用
      // {
      //   // 图谱问答
      //   path: "/apply/answer",
      //   component: () => import("@/views/answer"),
      // },
      // {
      //   // 场景自动生成引擎
      //   path: "/apply/engine",
      //   component: () => import("@/views/apply/engine.vue"),
      // },
    ],
  },
  //学生端
  {
    path: "/relation/stu_coneptmap",
    component: stu_2LayoutBasic3,
    redirect: "/relation/stu_coneptmap",
    children: [
      {
          // 知识导图
          path: "/relation/stu_coneptmap",
          component: () => import("@/views/relation/stu_coneptmap.vue"),
          name: 'stu_coneptmap',
        },
        {
          // 知识资源
          path: "/relation/stu_knowledgedisplay",
          component: () => import("@/views/relation/stu_knowledgedisplay.vue"),
          name: 'stu_knowledgedisplay',
          beforeEnter: (to, from, next) => {
            console.log('from.name:', from.name);
            if (from.name === 'result'&& to.params.isKnowledgeLink) {
              // 假设这里有一个全局的事件总线来传递数据
              console.log('准备触发 setShowTest 事件');
              setTimeout(() => {
                Vue.prototype.$eventBus.$emit('setShowTest', true);
                console.log('setShowTest 事件已触发');
              }, 10);
            }
            next();
          }
        },
        {
          // 知识评测
          path: "/ques/index",
          component: () => import("@/views/ques/index.vue"),
          name: 'ques',
          meta: {
            keepAlive: true
          }
        },
        {
          // 历史记录
          path: "/ques/result",
          component: () => import("@/views/ques/result.vue"),
          name: 'result'
        },
        ]
},
];
// const whiteList = [
//   '/mergeGraph/newExtract',

// ];
const router = new VueRouter({
  routes,
});

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // 获取 token
  const tokenStr = window.sessionStorage.getItem("token");

  // 如果目标页面是登录页面 "loginOLD" 且用户没有登录，跳转到登录页 "loginOLD"
  if (to.path === "/loginOLD" && !tokenStr) {
    return next();  // 如果没有 token，继续访问登录页
  }
  // 如果目标页面是退出登录后的页面 "login" 且用户没有登录，跳转到退出登录后的页面 "login"
  if (to.path === "/login" && !tokenStr) {
    return next();  // 没有 token，继续访问退出登录后的页面
  }

   // 如果没有 token 且访问的是非登录页面，跳转到退出登录后的页面 "login"
   if (!tokenStr && to.path !== "/login" && to.path !== "/loginOLD") {
    return next("/login");  // 未登录时，跳转到退出登录后的页面
  }
  // 如果目标页面是登录页面 "loginOLD" 且用户已登录，跳转到主页或其他已登录后的页面
  if (to.path === "/loginOLD" && tokenStr) {
    return next("/project");  // 已登录，跳转到主页
  }
  // 如果用户未登录但访问的是登录页面或根路径时，避免直接跳转到 loginOLD
  if (!tokenStr && (to.path === "/" || to.path === "/login")) {
    return next("/loginOLD");
  }
  // 权限校验：假设通过 userRole 判断，角色权限校验
  const userRole = window.sessionStorage.getItem('userRole');  // 假设角色为 admin_teacher
  const allowedRoutes = rolePermissions[userRole];  // 获取用户角色的权限

  // 检查当前路由是否被允许访问
  if (allowedRoutes && allowedRoutes.includes(to.path)) {
    return next();  // 如果有权限，放行
  } else {
    return next("/home");  // 如果没有权限，跳转到主页
  }
});



// token失效后给出提示并自动退出登录
// let intervalId; 
// router.beforeEach((to, from, next) => {
//   clearInterval(intervalId);
//   intervalId = setInterval(() => {
//     const tokenStr = window.sessionStorage.getItem('token');
//     if (!tokenStr && to.path !== '/login') {
//       clearInterval(intervalId); 
//       MessageBox.confirm('登录已过期，请重新登录。点击确认跳转到登录页面。', '提示', {
//         confirmButtonText: '确认',
//         type: 'warning',
//         showCancelButton: false 
//       }).then(() => {
//         next('/login'); 
//       });
//     }
//   }, 1000);
//   next();
// });

export default router;
